import React, { useState, useEffect } from "react";
import {
    useForm,
    FormProvider,
    useFormContext,
    useWatch,
} from "react-hook-form";
//Material-UI
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { TextField, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import WebIcon from '@material-ui/icons/Web';
//Component
import * as common from "./../../utils/common-function";
import { ReactTable } from "../../stories/react-table-serverside";
import { Modal } from "./../../stories/modal";
import { ModalLoading } from "./../../stories/modalLoading";
import ModalExportAll from "./query-export";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
//Function
import * as alertDialog from "./../../utils/alert";
import * as api from "./api";
import { buildParameter } from "./parameter";
import { formatDateTime } from "../../utils/common-function";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 10,
        position: "fixed",
        width: "100%"
    },
    LayoutScreenLeft: {
        width: "100%",
        height: "100vh",
        borderRight: '1px solid #000',
    },
    LayoutScreenRight: {
    },
    textarea: {
        resize: "both",
    },
    NewConnect: {
        width: "99%",
        margin: 'auto',
        textAlign: "center",
        marginTop: "5px",

    },
    ConnectInfo: {
        width: "99%",
        margin: 'auto',
        textAlign: "center",
        marginTop: "5px",
        border: '1px solid #000'

    },
    alignLeft: {
        width: "100%",
        textAlign: "left",
    },
    alignRight: {
        width: "100%",
        textAlign: "right",
    },
    areaButton: {
        width: "100%",
        marginTop: "5px",
        marginBottom: "5px",

    },
    query: {
        width: "99%",
        margin: 'auto',
        textAlign: "center",
        marginTop: "5px",

    },
    queryResult: {
        width: "99%",
        height: '20vh',
        textAlign: "Left",
        marginTop: "5px",
    },
    btnDisconn: {
        background: "#DC143C",
        marginLeft: "10px",
    }
}));

function QueryScreen() {
    const methods = useForm();
    const { register, setValue, getValues, reset } = methods;
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [Column, setColumn] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalRequest, setOpenModalRequest] = useState(false);
    const [openModalExport, setOpenModalExport] = useState(false);
    const [ConnectInfo, setConnectInfo] = useState([]);
    const [ResultListTable, setResultListTable] = useState([]);
    const [ResultList, setResultList] = useState([]);
    const [CountResultList, setCountResultList] = useState([]);
    const [queryExport, setQueryExport] = useState('');
    const [checkConnDB, setCheckConnDB] = useState(false);
    const [reloadTable, setReloadTable] = useState(false);
    const [listDB, setListDB] = useState([]);

    let PageSize = 50;

    const onOpenModal = () => {
        setOpenModal(true);
    };
    const onCloseModal = (param) => {
        setOpenModal(false);
        fetch();
    };

    const onCancelExcution = async () => {
        let api_res = await api.cancelRequest();
        setOpenModalRequest(false);
    };

    const onOpenExportAll = async () => {
        setOpenModalExport(true);
    };
    const onCloseExportAll = async () => {
        setOpenModalExport(false);
    };

    const fetch = async () => {
        let res = await api.GetConnectInfo();
        let resListDB = await api.GetListDB();
        setConnectInfo(res);
        setListDB(resListDB);
        setCheckConnDB(res?.Result?.userName ? false : true);
    };
    useEffect(() => {
        fetch();
    }, []);

    useEffect(() => {
        if (common.isEmptyObj(ResultList.Columns)) {
            setColumn([]);
            return;
        }
        let col = [{ dataField: "#id#", text: "#id#", sort: true, hidden: true, csvExport: false }];
        for (var propertyName in ResultList.Columns) {
            col.push({
                dataField: ResultList.Columns[propertyName],
                text: ResultList.Columns[propertyName],
                sort: true,
            });

        }
        setColumn(col);
    }, [ResultList]);

    const ExecQuery = async (pagesize, pageindex, sortOrder, sortField, tableChange) => {
        setOpenModalRequest(true);
        let param = buildParameter.ExecuteQuery(getValues().Query, pagesize, pageindex, sortOrder, sortField, tableChange);
        //console.log(param);
        let res = await api.ExecuteQuery(param);
        if (res) {
            setReloadTable(tableChange ? false : true);
            setQueryExport(param);
            setCountResultList(res?.TotalRows);
            setResultList(res);
            setOpenModalRequest(false);
        }
    }
    const onTableChange = (type, newState) => {

        ExecQuery(newState.sizePerPage, newState.page, newState.sortOrder, newState.sortField, true);
        // setReloadTable(false);
    }

    const DisconnectDB = async () => {
        let res = await alertDialog.ConfirmCommon("Do you want to disconnect database ?", "Yes", "No");
        if (!res) return;


        let api_res = await api.DisconnectDatabase();
        if (api_res.ResultCode === 30) {
            alertDialog.Success("Disconnected!");
            fetch();
        }

    };
    const ExportCSV = async () => {
        if (ResultList?.Rows?.length > 10000) {
            alertDialog.ErrorDialog("Can't download Maximun 10K records.");
            return;
        }
        let nameFile = "Export -" + formatDateTime(new Date()) + '.csv';
        //let param = buildParameter.ExecuteQuery(getValues());
        //let param = buildParameter.ExecuteQuery(queryExport);

        let res = await api.ExportCSV(queryExport);
        const blob = new Blob(['\ufeff' + res], { type: "text/csv; charset=UTF-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', url);
        a.setAttribute('download', nameFile);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <BaseContainer maxWidth={false}>
            <Paper elevation={3} p={1} m={1} style={{ height: '80vh', overflowY: "auto" }}  >
                <Box p={1} >
                    <Box display="flex" flexDirection="row" p={1} style={{ height: "40px" }}>
                        <h2 style={{ fontWeight: 'bold' }}>Direct Query</h2>
                        <Box flexGrow={1}></Box>
                        <Grid item xs={2} className={classes.alignRight}>
                            {<Button variant="contained" color="primary" onClick={onOpenModal} > Connect</Button>}
                            {<Button variant="contained" color="secondary" className={classes.btnDisconn} onClick={DisconnectDB} > Disconnect</Button>}

                        </Grid>
                    </Box>
                    <Box p={1}>

                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {/* <div className={classes.NewConnect}>
                        {<Button variant="contained" color="primary" onClick={onOpenModal} > Connect</Button>}
                        {<Button variant="contained" color="secondary" className={classes.btnDisconn} onClick={DisconnectDB} > Disconnect</Button>}
                    </div> */}
                            {/* <div className={classes.ConnectInfo}>
                        Connect Server : {ConnectInfo?.Result?.hostName || ''}
                        <br />UserName : {ConnectInfo?.Result?.userName || ''}
                        <br />Database : {ConnectInfo?.Result?.dataBase || ''}
                    </div> */}

                            <ModalConnection connectInfo={ConnectInfo} listDatabase={listDB} open={openModal} onClose={onCloseModal} />
                            <ModalLoading open={openModalRequest} onCancel={onCancelExcution} />
                            <ModalExportAll open={openModalExport} queryInfo={queryExport.sqlQuery} onClose={onCloseExportAll} />
                            <br />
                            {/* </Grid>
                <Grid item xs={10}> */}
                            <Grid container spacing={0} className={classes.alignLeft}>
                                <Grid item xs={10}>
                                    {/* <h3>Direct Query</h3> */}
                                </Grid>
                                <Grid item xs={2} className={classes.alignRight}>
                                    {/* {<Button variant="contained" color="primary" onClick={onOpenModal} > Connect</Button>}
                                    {<Button variant="contained" color="secondary" className={classes.btnDisconn} onClick={DisconnectDB} > Disconnect</Button>} */}

                                </Grid>
                            </Grid>
                            <div className={classes.query}>
                                <TextField
                                    id="outlined-textarea"
                                    name="Query"
                                    inputRef={register}
                                    label="Query "
                                    placeholder="Sql query here ..."
                                    multiline
                                    variant="outlined"
                                    rows={10}
                                    fullWidth
                                    className={classes.textarea}
                                    disabled={checkConnDB}
                                />
                                <div className={classes.areaButton} >
                                    <Grid container spacing={0} className={classes.alignLeft}>
                                        <Grid item xs={10}>
                                            <Button variant="contained" color="primary" disabled={checkConnDB} onClick={() => { ExecQuery(PageSize, 0); }}>
                                                Execute
                                            </Button>
                                        </Grid>
                                        <Grid item xs={2} className={classes.alignRight}>
                                            {/* {Column.length > 0 ? (<button className="btn btn-success" disabled={checkConnDB} onClick={ExportCSV}>
                                        Export Page</button>) : null} */}
                                            &nbsp;
                                            {Column.length > 0 ? (<button className="btn btn-success" disabled={checkConnDB} onClick={onOpenExportAll}>
                                                Export</button>) : null}
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>

                            <Divider />
                            <div className={classes.queryResult}>
                                {Column.length > 0 ? (
                                    <ReactTable
                                        keyField="#id#"
                                        data={
                                            (ResultList.Rows && ResultList.Rows.map((el, idx) => ({ ...el, "#id#": idx }))) || []
                                        }
                                        columns={Column}
                                        remote={{ pagination: true, filter: true, sort: true }}
                                        onTableChange={onTableChange}
                                        totalData={CountResultList}
                                        tableReload={reloadTable}
                                    />
                                ) : null}
                                {
                                    typeof ResultList === "string" ? ResultList : null
                                }
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </BaseContainer>
    );
}

function ModalConnection(props) {
    const { open } = props;
    const ConnectForm = useForm({ mode: "onChange" });
    const { connectInfo, listDatabase, search = () => { }, ...otherprops } = props;
    const { register, getValues } = ConnectForm;
    const { setValue, setError, clearErrors, errors } = ConnectForm;
    const [hostKey, setHostKey] = useState('');
    const [hostTitle, setHostTitle] = useState('');
    const [hostName, setHostName] = useState('');
    const [dbName, setDBName] = useState('');
    const [dbPort, setDBPort] = useState('');
    const [backUpServer, setBackUpServer] = useState('');
    useEffect(() => {
        if (!open) return;
    }, [open]);

    const handleChangeHostName = (event) => {
        const getDBInfo = listDatabase?.Result.filter(x =>
            x.hostName === event.target.value
        );
        //console.log(event.target);
        setHostKey(getDBInfo[0]?.hostKey);
        setHostTitle(getDBInfo[0]?.hostTitle);
        setHostName(event.target.value);
        setDBName(getDBInfo[0]?.dataBase);
        setDBPort(getDBInfo[0]?.dbPort);
        setBackUpServer(getDBInfo[0]?.backupServer);
    };

    const SaveConfig = async () => {
        const paramBackUpServ = backUpServer ==="" ? connectInfo?.Result?.backupServer : backUpServer;
        const paramPort = dbPort ==="" ? connectInfo?.Result?.dbPort : dbPort;
        const paramHost = hostName ==="" ? connectInfo?.Result?.hostName : hostName;
        const paramHostKey = hostKey ==="" ? connectInfo?.Result?.hostKey : hostKey;
        const paramHostTitle = hostTitle ==="" ? connectInfo?.Result?.hostTitle : hostTitle;
        console.log(paramHostKey);
        let param = buildParameter.SaveConnect(paramHostKey,paramHost,paramBackUpServ,paramPort, getValues(),paramHostTitle);

        //clearErrors("HostName");
        clearErrors("UserName");
        // if (common.isEmptyStr(param.hostName.trim())) {
        //     setError("HostName", { type: "CheckNull", message: "Please input HostName." });
        //     return;
        // }
        if (common.isEmptyStr(param.userName.trim())) {
            setError("UserName", { type: "CheckNull", message: "Please input UserName." });
            return;
        }

        let getcode = await api.ConnectDatabase(param);
        if (getcode.ResultCode === 10) { //connectSuccess
            props.onClose();
            alertDialog.ConnectSuccessDialog("Connect Success!");
        }
        if (getcode.ResultCode === 20) { //connectError
            alertDialog.ErrorDialog("Connect Error!");
        }
    };
    const ClearError = async (e) => {
        clearErrors(e.target.name);
    };

    const handleEnter = (e) => {
        if (e.keyCode === 13) {
            SaveConfig();
        }
    }
    return (
        <>
            {/* {console.log(connectInfo)} */}
            <Modal {...otherprops} onSave={SaveConfig} SaveText="Connect" title="New Connection">
                <Box m={3} maxWidth="500px" flexGrow={1}>
                    {/* <TextField
                        id="HostName-textarea"
                        name="HostName"
                        inputRef={register}
                        label="HostName "
                        placeholder=""
                        variant="filled"
                        onChange={ClearError}
                        rows={1}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                        }}
                        defaultValue={connectInfo?.Result != null ? connectInfo?.Result?.hostName : ""}
                        error={errors?.hasOwnProperty("HostName")}
                        helperText={errors?.["HostName"]?.message || ''}
                    /> */}
                    <FormControl fullWidth>
                        <InputLabel id="simple-select-outlined-label">HostName</InputLabel>
                        <Select
                            labelId="simple-select-outlined-label"
                            id="HostName-textarea"
                            name="HostName"
                            label="HostName "
                            variant="filled"
                            fullWidth
                            inputRef={register}
                            value={hostName === "" ? connectInfo?.Result?.hostName : hostName}
                            onChange={handleChangeHostName}

                        >
                            {listDatabase?.Result?.map((item) => (
                                <MenuItem key={item?.hostName} value={item?.hostName}>{item?.hostTitle}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Box m={3} maxWidth="500px" flexGrow={1}>
                    <TextField
                        id="UserName-textarea"
                        name="UserName"
                        inputRef={register}
                        label="UserName "
                        placeholder=""
                        onChange={ClearError}
                        multiline
                        variant="outlined"
                        rows={1}
                        fullWidth
                        defaultValue={connectInfo?.Result != null ? connectInfo?.Result?.userName : ""}
                        error={errors?.hasOwnProperty("UserName")}
                        helperText={errors?.["UserName"]?.message || ''}
                    />
                </Box>
                <Box m={3} maxWidth="500px" flexGrow={1}>
                    <TextField
                        id="Password-textarea"
                        name="Password"
                        label="Password"
                        inputRef={register}
                        type="password"
                        autoComplete="current-password"
                        variant="outlined"
                        rows={1}
                        fullWidth
                        defaultValue={connectInfo?.Result != null ? connectInfo?.Result?.passWord : ""}
                    // error={errors && errors.hasOwnProperty("Password")}
                    // helperText={errors && errors["Password"] || ''}
                    />
                </Box>
                <Box m={3} maxWidth="500px" flexGrow={1}>
                    <TextField
                        id="Database-textarea"
                        name="Database"
                        inputRef={register}
                        label="Database "
                        placeholder=""
                        multiline
                        variant="filled"
                        rows={1}
                        fullWidth
                        InputProps={{
                            readOnly: true,
                        }}
                        //defaultValue={connectInfo?.Result != null ? connectInfo?.Result?.dataBase : ""}
                        //value={dbName}
                        value={dbName === "" ? connectInfo?.Result?.dataBase : dbName}
                        onKeyDown={handleEnter}
                    // error={errors && errors.hasOwnProperty("Database")}
                    // helperText={errors && errors["Database"] || ''}
                    />
                </Box>
            </Modal>
        </>
    );
}

function TreeListTable(props) {

    const classes = useStyles();
    const { tableColumns = () => { }, ...otherprops } = props;
    const [expanded, setExpanded] = React.useState([]);
    const [selected, setSelected] = React.useState([]);


    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleSelect = (event, nodeIds) => {
        setSelected(nodeIds);
    };

    const i = 1;
    const content = (
        <Box
            height="100%"
            display="flex"
            width="100%"
            flexDirection="column"
        >
            <Box p={2}>
                <TreeView
                    className={classes.root}
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<WebIcon />}
                    expanded={expanded}
                    selected={selected}
                    onNodeToggle={handleToggle}
                >

                    {typeof tableColumns !== "string" ? (tableColumns && tableColumns.map((item, i) => (
                        <TreeItem key={"a" + i} nodeId={"a" + i} label={item.TableName}>
                            {item.Columns.map((itemchild, i) => (
                                <TreeItem key={"b" + i} nodeId={"b" + i} label={itemchild.Name} />
                            ))}
                        </TreeItem>
                    ))) : null}
                </TreeView>
            </Box>
        </Box>
    );

    return (
        <div>
            {content}
        </div>
    );
};

export default QueryScreen;
